var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SeoPillarLandingPage',{attrs:{"content":_vm.$t('seoPillarPaginaDeVendas'),"faq-src":"/seo-faq/pagina-de-vendas-para-afiliados.json"}})}
var staticRenderFns = []

export { render, staticRenderFns }